if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}


// minicon — Desktop mouse drag for PDP gallery
// minicon — Desktop mouse drag for PDP gallery
(function () {
  function initGalleryDrag(gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var slider = viewer && viewer.querySelector('.product__media-list');
    if (!slider) return;

    var startX = 0, dragDelta = 0, dragging = false, didDrag = false;

    slider.style.cursor = 'grab';

    slider.addEventListener('mousedown', function (e) {
      startX = e.clientX;
      dragDelta = 0;
      didDrag = false;
      dragging = true;
      slider.style.cursor = 'grabbing';
      slider.style.userSelect = 'none';
    });

    document.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      dragDelta = e.clientX - startX;
      if (Math.abs(dragDelta) > 5) didDrag = true;
    });

    document.addEventListener('mouseup', function () {
      if (!dragging) return;
      dragging = false;
      slider.style.cursor = 'grab';
      slider.style.userSelect = '';

      if (Math.abs(dragDelta) > 50) {
        var slides = Array.from(slider.querySelectorAll('.product__media-item'));
        var activeIdx = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
        if (activeIdx === -1) activeIdx = 0;

        var nextIdx = dragDelta < 0
          ? Math.min(activeIdx + 1, slides.length - 1)
          : Math.max(activeIdx - 1, 0);

        if (nextIdx !== activeIdx) {
          var mediaId = slides[nextIdx].dataset.mediaId;
          var galleryEl = gallery;
          if (galleryEl.setActiveMedia) {
            galleryEl.setActiveMedia(mediaId, false);
          } else {
            var thumb = gallery.querySelector('[data-target="' + mediaId + '"] button');
            if (thumb) thumb.click();
          }
        }
      }
      dragDelta = 0;
    });

    slider.addEventListener('dragstart', function (e) { e.preventDefault(); });

    slider.addEventListener('click', function (e) {
      if (didDrag) { e.preventDefault(); e.stopPropagation(); didDrag = false; }
    }, true);
  }

  function initGalleryArrows(gallery) {
    var prevBtn = gallery.querySelector('.chandrikas-gallery-prev');
    var nextBtn = gallery.querySelector('.chandrikas-gallery-next');
    if (!prevBtn || !nextBtn) return;

    function getSlides() {
      return Array.from(gallery.querySelectorAll('.product__media-item'));
    }

    function getActiveIdx(slides) {
      var idx = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      return idx === -1 ? 0 : idx;
    }

    function navigate(dir) {
      var slides = getSlides();
      var activeIdx = getActiveIdx(slides);
      var nextIdx = activeIdx + dir;
      if (nextIdx < 0 || nextIdx >= slides.length) return;
      var mediaId = slides[nextIdx].dataset.mediaId;
      if (gallery.setActiveMedia) {
        gallery.setActiveMedia(mediaId, false);
      } else {
        var thumb = gallery.querySelector('[data-target="' + mediaId + '"] button');
        if (thumb) thumb.click();
      }
    }

    prevBtn.addEventListener('click', function () { navigate(-1); });
    nextBtn.addEventListener('click', function () { navigate(1); });
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      initGalleryDrag(gallery);
      initGalleryArrows(gallery);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();